export default __webpack_public_path__ + "static/media/queuing_system.bf5296e7.gzip";